import axios from "axios";
import React, { useEffect, useState } from "react";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import ClipLoader from "react-spinners/ClipLoader";
import { Link, useParams, useHistory } from "react-router-dom";
import Footer from "../../Footer";
import getSymbolFromCurrency from "currency-symbol-map";
import Variants from "./VariantsEdit";

function Editproducts(props) {
  const { productId } = useParams();
  const history = useHistory();
  const defaultImageUrl =
    "https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png";

  const { token } = isAutheticated();
  const [taxs, setTax] = useState([]);
  const [Categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currency, setCurrency] = useState();
  const [images, setImages] = useState({
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
  }); // can contain either File objects (new uploads) or URL strings (existing)
  const [imagesUrl, setImagesUrl] = useState([]); // preview urls (strings)
  const [openModal, setOpenModal] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [imageTitle, setImageTitle] = useState("");
  const [imageId, setImageId] = useState(0);

  const [state, setstate] = useState({
    title: "",
    description: "",
    category: "",
    status: "",
    image: "",
    price: "",
    sale_price: "",
    sku: "",
    quantity: "",
    continue_selling: false,
    track_quantity: false,
    statusState: true,
    initialCategory: "",
  });

  const [variantChecked, setVariantChecked] = useState(false);
  const [optionList, setOptionList] = useState([{ name: "", value: [] }]);
  const [variants, setVariants] = useState([]);
  const [variantId, setVariantId] = useState("");
  const [variantEdited, setVariantEdited] = useState(false);
  const [originalVariants, setOriginalVariants] = useState([]);

  const wordLimit = {
    title: 40,
    description: 1000,
    price: 12,
    sale_price: 12,
    SKU: 10,
    quantity: 10,
  };

  const [titleLen, setTitleLen] = useState(wordLimit.title);
  const [descriptionLen, setDescriptionLen] = useState(wordLimit.description);
  const [priceLen, setPriceLen] = useState(wordLimit.price);
  const [salePriceLen, setSalePriceLen] = useState(wordLimit.sale_price);
  const [SKULen, setSKULen] = useState(wordLimit.SKU);
  const [quantityLen, setQuantityLen] = useState(wordLimit.quantity);
  const [productLoading, setProductLoading] = useState(true);

  useEffect(() => {
    async function fetchCurrency() {
      try {
        const res = await axios.get(`${API}/api/user`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrency(res.data.data.settings.currency);
      } catch (err) {
        console.error("Failed to fetch user/currency", err);
      }
    }
    if (token) fetchCurrency();
  }, [token]);

  // fetch categories and product data
  useEffect(() => {
    const getData = async () => {
      try {
        setProductLoading(true);

        const [catRes, prodRes] = await Promise.all([
          axios.get(`${API}/api/category`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API}/api/product/${productId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        // Normalize categories response: handle response where data may be array or nested
        const categoriesData =
          Array.isArray(catRes.data) && catRes.data.length > 0
            ? catRes.data
            : catRes.data?.categories || [];

        setCategories(categoriesData);

        const product = prodRes.data?.data || prodRes.data;

        // initialCategory object from categories list
        const categoryObj = categoriesData.find(
          (c) => c._id === product?.category
        );

        setstate((prev) => ({
          ...prev,
          title: product?.title || "",
          description: product?.description || "",
          image: product?.image || "",
          price: product?.price ?? "",
          sale_price: product?.sale_price ?? "",
          sku: product?.sku ?? "",
          track_quantity: product?.track_quantity ?? false,
          quantity: product?.quantity ?? "0",
          status: product?.status ?? false,
          continue_selling: product?.continue_selling ?? false,
          initialCategory: categoryObj || "",
          category: categoryObj?._id || "",
          imageUrl: product?.image || "",
        }));

        // prepare images and preview urls
        const previews = [];
        const imagesObj = { image1: "", image2: "", image3: "", image4: "", image5: "" };

        for (let i = 1; i <= 5; i++) {
          const key = `image${i}`;
          if (product?.[key]) {
            previews.push(product[key]);
            imagesObj[key] = product[key]; // store URL string for existing image
          }
        }
        setImagesUrl(previews);
        setImages(imagesObj);

        // if no variants, adjust word limits based on product
        if (!product?.variants) {
          setTitleLen(wordLimit.title - (product?.title?.length || 0));
          setDescriptionLen(wordLimit.description - (product?.description?.length || 0));
          setPriceLen(wordLimit.price - ((product?.price?.toString()?.length) || 0));
          setSKULen(wordLimit.SKU - ((product?.sku?.toString()?.length) || 0));
          if (product?.track_quantity) {
            setQuantityLen(wordLimit.quantity - ((product?.quantity?.toString()?.length) || 0));
          }
        }

        // handle variants if present (kept commented in original)
        // ...
      } catch (error) {
        console.error("Error fetching product data", error);
      } finally {
        setProductLoading(false);
      }
    };

    if (token && productId) getData();
  }, [token, productId]);

  useEffect(() => {
    if (state.quantity === "") {
      setstate((prev) => ({ ...prev, quantity: "0" }));
    }
  }, [state.quantity]);

  // helper: check variants validity
  const checkAllVariants = () => {
    if (!variantChecked) {
      return false;
    }
    // return true if any variant has invalid fields
    return variants.some((item) => {
      const priceEmpty = item.price === "" || item.price == null;
      const quantityEmpty = item.quantity === "" || item.quantity == null;
      const skuEmpty = item.SKU === "" || item.SKU == null;
      return priceEmpty || quantityEmpty || skuEmpty;
    });
  };

  const handleVariants = async () => {
    const formdata = new FormData();

    optionList.forEach((item) => {
      formdata.append("options", item.name);
      // if values array, append joined or each value depending on backend expectations
      formdata.append("value", Array.isArray(item.value) ? item.value.join(",") : item.value);
    });

    variants.forEach((item) => {
      formdata.append("variant_title", item.variant);
      formdata.append("variant_price", parseFloat(item.price || 0));
      formdata.append("variant_quantity", parseInt(item.quantity || 0, 10));
      formdata.append("variant_sku", item.SKU);
      if (item.image && item.image instanceof File) {
        formdata.append("file", item.image);
      }
    });

    return axios.put(`${API}/api/product/update_variant/${variantId}`, formdata, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const handleSubmit = async () => {
    if (checkAllVariants()) {
      alert("Please enter correct values in variant");
      return;
    }

    const formdata = new FormData();
    setLoading(true);

    formdata.append("title", state.title || "");
    formdata.append("description", state.description || "");
    formdata.append("category_id", state.category || "");
    formdata.append("sale_price", state.sale_price || "");
    formdata.append("quantity", state.quantity || "0");
    formdata.append("continue_selling", !!state.continue_selling);
    formdata.append("track_quantity", !!state.track_quantity);
    formdata.append("status", state.status);

    if (variantChecked) {
      formdata.append("variants", variantId || "");
      formdata.append("variant_flag", true);
    } else {
      formdata.append("variant_flag", false);
      formdata.append("price", state.price || 0);
      formdata.append("sku", state.sku || "");
    }

    // only append a new single image file if the 'image' state is a File
    if (state?.image && state.image instanceof File) {
      formdata.append("image", state.image);
    }

    // append only File objects from images (new uploads). If backend expects URLs for existing images, skip them here.
    for (let i = 1; i <= 5; i++) {
      const imgVal = images[`image${i}`];
      if (imgVal && imgVal instanceof File) {
        formdata.append("images", imgVal);
      }
    }

    try {
      const res = await axios.put(`${API}/api/product/${productId}`, formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res) {
        if (variantChecked && variantEdited) {
          await handleVariants(); // await variant update before redirecting
        }
      }

      history.push("/comproducts");
    } catch (error) {
      console.error("Failed to update product", error);
      alert("Editing product failed");
    } finally {
      setLoading(false);
    }
  };

  const createVariants = (variants) => {
    const totalVariants = variants.variant_title.length;
    let tempVariants = [];
    for (let i = 0; i < totalVariants; i++) {
      tempVariants = [
        ...tempVariants,
        {
          variant: variants.variant_title[i],
          price: variants.variant_price[i],
          quantity: variants.variant_quantity[i],
          SKU: variants.variant_sku[i],
          image: variants.variant_image[i],
        },
      ];
    }

    return tempVariants;
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setstate((prev) => ({
        ...prev,
        image: file,
        imageUrl: URL.createObjectURL(file),
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setstate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;
    setstate((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const editHandler = (e, type) => {
    const value = e.target.value;
    const length = value.length;

    switch (type) {
      case "title":
        if (wordLimit.title - length !== -1) {
          handleChange(e);
          setTitleLen(wordLimit.title - length);
        }
        break;
      case "description":
        if (wordLimit.description - length !== -1) {
          handleChange(e);
          setDescriptionLen(wordLimit.description - length);
        }
        break;
      case "price":
        if (e.target.value === "" || (!isNaN(value) && wordLimit.price - length !== -1)) {
          handleChange(e);
          setPriceLen(wordLimit.price - length);
        }
        break;
      case "SKU":
        if (e.target.value === "" || (!isNaN(value) && wordLimit.SKU - length !== -1)) {
          handleChange(e);
          setSKULen(wordLimit.SKU - length);
        }
        break;
      case "quantity":
        if (e.target.value === "" || (!isNaN(value) && wordLimit.quantity - length !== -1)) {
          handleChange(e);
          setQuantityLen(wordLimit.quantity - length);
        }
        break;
      default:
        console.log("Incorrect Type");
    }
  };

  const handleSingleImage = (event) => {
    const file = event.target.files[0];
    if (file && file.type.split("/")[0] === "image") {
      setstate((prev) => ({ ...prev, image: file }));
      setstate((prev) => ({ ...prev, imageUrl: URL.createObjectURL(file) }));
    } else {
      setstate((prev) => ({ ...prev, image: "" }));
      event.target.value = null;
      alert("Please upload a valid image");
    }
  };

  const imageHandler = (e) => {
    const files = Array.from(e.target.files || []);
    const totalNew = files.length;
    const currentPreviewCount = imagesUrl.length;
    if (totalNew + currentPreviewCount > 5) {
      alert("Cannot upload more than 5 images");
      return;
    }

    const newPreviews = [...imagesUrl];
    const newFiles = [];

    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      if (f && f.type.split("/")[0] === "image") {
        newPreviews.push(URL.createObjectURL(f));
        newFiles.push(f);
      } else {
        alert("Please upload a valid image");
      }
    }

    // map newFiles into images object (starting from first empty slot)
    const newImagesState = { ...images };
    let fileIndex = 0;
    for (let i = 1; i <= 5 && fileIndex < newFiles.length; i++) {
      if (!newImagesState[`image${i}`] || typeof newImagesState[`image${i}`] === "string") {
        newImagesState[`image${i}`] = newFiles[fileIndex++];
      }
    }

    setImages(newImagesState);
    setImagesUrl(newPreviews);
  };

  const openImage = (image) => {
    const idx = imagesUrl.indexOf(image);
    const newImageId = idx >= 0 ? idx : 0;
    setImageId(newImageId);
    setImageTitle(`image${newImageId + 1}`);
    setCurrentImage(imagesUrl[newImageId]);
    setOpenModal(true);
  };

  const deleteImage = () => {
    const newImagesUrl = imagesUrl.filter((_, i) => i !== imageId);
    setImagesUrl(newImagesUrl);

    // rebuild images object from remaining previews (URLs or File names)
    const newImages = { image1: "", image2: "", image3: "", image4: "", image5: "" };
    for (let i = 0; i < newImagesUrl.length; i++) {
      newImages[`image${i + 1}`] = newImagesUrl[i];
    }
    setImages(newImages);
    setOpenModal(false);
  };

  const deleteSingleImage = () => {
    setstate((prev) => ({ ...prev, image: null, imageUrl: "" }));
  };

  const handleStatus = (e) => {
    if (e.target.value === "Active") {
      setstate((prev) => ({ ...prev, status: true }));
    } else {
      setstate((prev) => ({ ...prev, status: false }));
    }
  };

  if (productLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center p-4  rounded shadow">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* page title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Edit Product</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item active">OTT Shop</li>
                    <li className="breadcrumb-item active">Edit Product</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Save options */}
          <div className="row">
            <div className="col-12">
              <div className="form-group text-right">
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                >
                  <ClipLoader loading={loading} size={18} />
                  {!loading && "Save"}
                </button>
                <Link to="/comproducts">
                  <button
                    type="button"
                    className="btn btn-success btn-cancel waves-effect waves-light mr-3"
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Row 1 */}
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="label-100">Title</label>
                          <input
                            name="title"
                            onChange={(e) => editHandler(e, "title")}
                            type="text"
                            value={state.title}
                            className="form-control input-field"
                            placeholder="Title"
                          />
                          <label className="label-100">
                            Characters Remaining : {titleLen}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group mb-30 width-100 row">
                        <label className="col-md-4 control-label">Description</label>
                        <div className="col-md-13">
                          <textarea
                            onChange={(e) => editHandler(e, "description")}
                            value={state.description}
                            name="description"
                            className="form-control input-field"
                            rows="5"
                            placeholder="Add description"
                          ></textarea>
                          <label className="label-100">
                            Characters Remaining : {descriptionLen}
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="label-100">Select Category</label>
                          <select
                            name="category"
                            defaultValue={state.initialCategory}
                            value={state.category}
                            onChange={(e) => handleChange(e)}
                            className="form-control  input-field"
                          >
                            <option value={state.initialCategory?._id}>
                              {state.initialCategory?.category || "Select"}
                            </option>
                            {Categories?.map((item, index) => (
                              <option key={index} value={item?._id}>
                                {item.category}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="label-100">Status</label>
                          <select
                            name="status"
                            value={state.status ? "Active" : "Inactive"}
                            onChange={handleStatus}
                            className="form-control  input-field"
                          >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Featured Image */}
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="form-group">
                      <label className="label-100">Upload Featured Product Image*</label>
                    </div>
                    <div className="form-group mb-30 width-100 row">
                      <label className="col-md-3 control-label">
                        Upload One Image Only
                        <br />
                        <span className="size">(320x180 px)</span>
                      </label>
                      <div className="col-md-3">
                        <img
                          src={state.imageUrl || state.image || defaultImageUrl}
                          width="150"
                          height="100"
                          alt="preview"
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="file"
                          onChange={handleSingleImage}
                          className="form-control input-field"
                          accept="image/*"
                        />
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => deleteSingleImage()}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Product images upload */}
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="form-group">
                      <label className="label-100">Upload Product Images*</label>
                    </div>
                    <div className="form-group mb-30 width-100 row">
                      <label className="col-md-4 control-label">
                        Upload Upto 5 Images
                        <br />
                        <span className="size">(320x180 px)</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          onChange={imageHandler}
                          className="form-control input-field"
                          accept="image/*"
                          multiple
                        />
                        {imagesUrl.length > 0 &&
                          imagesUrl.map((image, index) => (
                            <img
                              className="img-fluid mt-2 pr-2"
                              style={{
                                width: "75px",
                                height: "100px",
                                cursor: "pointer",
                              }}
                              alt={`preview-${index}`}
                              src={image}
                              onClick={() => openImage(image)}
                              key={index}
                            />
                          ))}

                        {openModal && (
                          <div
                            className="modal fade show"
                            id="exampleModalCenter"
                            tabIndex="-1"
                            aria-labelledby="exampleModalCenterTitle"
                            aria-modal="true"
                            role="dialog"
                            style={{ display: "block" }}
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalCenterTitle">
                                    {imageTitle}
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setOpenModal(false)}
                                  />
                                </div>
                                <div className="modal-body">
                                  <img
                                    className="img-fluid mt-2 pr-2"
                                    style={{
                                      width: "360px",
                                      height: "459px",
                                    }}
                                    alt="preview-large"
                                    src={currentImage}
                                  />
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={() => setOpenModal(false)}
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => deleteImage()}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Price / sale price / SKU / variants */}
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body" style={variantChecked ? { backgroundColor: "#d4d4d4" } : null}>
                  <form>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label className="label-100">Sale Price*</label>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                {currency ? getSymbolFromCurrency(currency) : "$"}
                              </span>
                            </div>
                            <input
                              type="text"
                              name="sale_price"
                              onChange={(e) => setstate((prev) => ({ ...prev, sale_price: e.target.value }))}
                              className="form-control input-field"
                              value={state.sale_price}
                              disabled={variantChecked}
                            />
                          </div>
                          <label className="label-100">
                            Characters Remaining : {salePriceLen}
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* SKU and quantity area */}
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body" style={variantChecked ? { backgroundColor: "#d4d4d4" } : null}>
                  <form>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label className="label-100">SKU (Optional)</label>
                          <input
                            name="sku"
                            value={state.sku}
                            onChange={(e) => editHandler(e, "SKU")}
                            type="text"
                            className="form-control input-field"
                            disabled={variantChecked}
                          />
                          <label className="label-100">
                            Characters Remaining : {SKULen}
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* variant UI if needed */}
                    {/* {variantChecked && (
                      <Variants
                        currency={currency}
                        optionList={optionList}
                        setOptionList={setOptionList}
                        originalVariants={originalVariants}
                        setTotalVariants={setVariants}
                        variantEdited={variantEdited}
                        setVariantEdited={setVariantEdited}
                      />
                    )} */}
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* container-fluid */}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Editproducts;
